import React, { useState } from 'react';
import { TextField, Button, Box, Container, Typography, Select, MenuItem, Checkbox } from '@mui/material';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
// import { useNavigate } from 'react-router-dom';
import { getEnv } from "../libs/global";

const Dashboard = () => {

    //Obtener el dia actual
    const hoy = new Date();
    const yyyy = hoy.getFullYear();
    const mm = String(hoy.getMonth() + 1).padStart(2, '0');
    const dd = String(hoy.getDate()).padStart(2, '0');
    const fechaHoy = `${yyyy}-${mm}-${dd}`;
    
    const [fechaRegi, setFechaRegi] = useState(fechaHoy);
    const [userId, setUserId] = useState('');
    const [allRecords, setAllRecords] = useState([]);
    const [allEmpresas, setAllEmpresas] = useState([]);
    const [message, setMessage] = useState('');
    const conv = localStorage.getItem('conv');
    const [rows, setRows] = useState([]);
    const envel = getEnv();
    const estadoPends = `Pendiente`;
    const estadoAccep = `Aprobado`;
    const charSplit = "***";

    // const email = localStorage.getItem('email');

    // Modificamos las rutas para que envíen las solicitudes al backend PHP
    const handleGetAllRecords = async (limpiarMensaje = true) => {
        setRows([]);
        setAllRecords([]);
        setAllEmpresas([]);
        try {
            const response = await axios.post(`${envel.url}/backComerbasPHP/public/index.php`, {
                action: 'getAllRecords',
                fecha: fechaRegi?? '',
                user: userId?? '',
                conv
            });
            const responseData = response.data;
            // Verificar que la respuesta contiene el status y el record
            if (responseData.status === 'success' && responseData.records) {
                // Inicializa rows con valores por defecto
                const initial = responseData.records.filter(rd => rd.estadoApro === estadoPends).map((mp) => ({
                    iplan: mp.idPlanTitular,
                    ccosto: mp.idConvenio,
                    cplan: mp.idPlan,
                    nempr: mp.nmbEmpresa,
                    cconf: mp.codigoConfirm,
                    capro: 0
                }));
                setRows(initial);
                setAllRecords(responseData.records);
                setAllEmpresas(responseData.empresas);
                if (limpiarMensaje) {
                    setMessage('');  // Limpiamos cualquier mensaje de error
                }
            } else {
                setMessage(responseData.message);
            }
        } catch (error) {
            console.error('Error en la solicitud:', error);
            setMessage(error.response?.data?.message || 'Error al obtener el registro');
        }
    };

    const handleInputChange = (index, iplan, field, value) => {
        setFieldRow(index, 'iplan', iplan);
        let valueFina = value;
        if (field === 'ccosto') {
            const infoValue = value.split(charSplit);
            valueFina = infoValue[0]; // Convenio
            const valueCPlan = infoValue[1]; // Plan
            const selectedItem = allEmpresas.find(emp => `${emp.codiConvenio}${charSplit}${emp.codiPlan}` === value);
            console.log(allEmpresas);
            console.log(selectedItem);
            const valueNEmpr = selectedItem?.nombrEmpresa || "";
            console.log(valueNEmpr);
            setFieldRow(index, 'cplan', valueCPlan);
            setFieldRow(index, 'nempr', valueNEmpr);
        }
        setFieldRow(index, field, valueFina);
    };

    const setFieldRow = (index, field, value) => {
        setRows(prev => {
            const updated = [...prev];
            updated[index] = {
            ...updated[index],
            [field]: ['cplan', 'nempr'].includes(field) ? value : Number(value),
            };
            return updated;
        });
    };

    const repoResultDetalle = (listRows, respRows) => {
        listRows.forEach(lrow => {
            const respID = respRows.some(rp => `${rp.Contrato}` === `${lrow.iplan}`);
            const itemSpan = document.getElementById(`aproSpan${lrow.iplan}`);
            const itemCheck = document.getElementById(`aproCheck${lrow.iplan}`);
            let textEstado = lrow.capro === 1 || lrow.capro === '1'? 'Aprobado' : 'Rechazado';
            if (respID) {
                itemCheck.innerHTML = ``;
            } else if (itemCheck.innerHTML.length > 0) {
                textEstado = `Error Codigo`;
            }
            const infoSpan = getColorAprobacion(textEstado);
            itemSpan.style.color = infoSpan.color;
            itemSpan.innerHTML = infoSpan.text;
        });
    };

    const handleSaveAll = async () => {
        //Validar rows
        if (rows.length > 0) {
            const nopRows = rows.some((r) => {
                return (
                    r.iplan === 0 || r.iplan === '' ||
                    r.ccosto === 0 || r.ccosto === '' ||
                    r.cplan === 0 || r.cplan === '' ||
                    r.cconf === 0 || r.cconf === ''
                );
            });
            if (nopRows) {
                alert('Faltan parámetros de aprobacion, por favor validar nuevamente');
            } else {
                const confirmado = window.confirm("¿Realmente desea guardar los datos?");
                if (confirmado) {
                    try {
                        const response = await axios.post(`${envel.url}/backComerbasPHP/public/index.php`, {
                            action: 'setAllRecords',
                            rows
                        });
                        try {
                            const responseData = response.data;
                            // Verificar si la respuesta tiene status "success" o "error"
                            if (responseData.status === 'success') {
                                setMessage('Registros actualizados con éxito.');
                                // repoResultDetalle(responseData.execute);
                                repoResultDetalle(rows, responseData.execute);
                            } else if (responseData.status === 'error') {
                                // Mostrar el mensaje de error que viene del backend
                                setMessage(responseData.message || 'Error desconocido al actualizar los registros.');
                            } else {
                                setMessage('Respuesta inesperada del servidor.');
                            }
                        } catch (error) {
                            console.error('Error al parsear JSON:', error);
                            setMessage('Error al procesar la respuesta del servidor.');
                        }
                    } catch (error) {
                        console.error('Error en la solicitud:', error);
                        setMessage('Error al aprobar los registros.');
                    }
                }
            }
        } else {
            alert('No hay registros pendientes de validación');
        }
    };

    const onlyNumberTen = (e, max = 12) => {
        const isNumber = /[0-9]/.test(e.key);
        const isBackspace = e.key === 'Backspace' || e.key === 'Delete';
        const isSelection = window.getSelection().toString().length > 0;
        const inputLength = e.target.value.length;

        if (!isNumber && !isBackspace) {
            e.preventDefault(); // Bloquea todo lo que no sea número o retroceso
        }

        // Si no está seleccionando y ya hay 10 caracteres, bloquea más
        if (!isSelection && inputLength >= max && isNumber) {
            e.preventDefault();
        }
    }

    const getMenuItems = (convenios) => {
        return convenios.length > 0 ?
            convenios.map(empresa => 
                <MenuItem value={`${empresa.codiConvenio}${charSplit}${empresa.codiPlan}`}>
                    {empresa.nombrEmpresa}
                </MenuItem>
            ) : <></>;
    };

    const getColorAprobacion = (estado) => {
        return {
            color: {
                'Pendiente' : 'orange',
                'Aprobado' : 'green',
                'Rechazado' : 'red',
                'Error Codigo' : 'red'
            }[estado],
            text: estado.toUpperCase()
        };
    };

    const getSpanAprobacion = (idSpan, estado) => {
        const infoAprobacion = getColorAprobacion(estado);
        return <span id={`aproSpan${idSpan}`} style={{color: infoAprobacion.color, fontWeight: "bolder"}}>{infoAprobacion.text}</span>;
    }

      return (
        <Container
            sx={{
                textAlign: 'center',
            }}
        >
            <Box
                maxWidth="xs"
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5" >Dashboard de Aprobación</Typography>
                <TextField
                    type="date"
                    label="Fecha Registro"
                    value={fechaRegi}
                    onChange={(e) => setFechaRegi(e.target.value)}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />
                <TextField
                    label="ID Usuario "
                    value={userId}
                    onChange={(e) => setUserId(e.target.value)}
                    onKeyPress={onlyNumberTen}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    placeholder='Opcional'
                />
                <Button size="medium" variant="contained" color="primary" onClick={handleGetAllRecords} >
                    Obtener Registros
                </Button>

                {allRecords.length > 0 && (
                    <Container
                        sx={{
                            marginTop: 3,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h6" >TITULARES</Typography>

                        <TableContainer component={Paper} sx={{ marginTop: 8, width: '100%', margin: '0 auto' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Identificación</TableCell>
                                        <TableCell>Colaborador</TableCell>
                                        <TableCell>C. Costo</TableCell>
                                        {/* <TableCell>Cod. Confirmación</TableCell> */}
                                        <TableCell>Aprobar</TableCell>
                                        <TableCell>Estado</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allRecords.map((itemTitular, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{itemTitular.idTitular}</TableCell>
                                            <TableCell>{itemTitular.nombreTitular + ' ' + itemTitular.apellidoTitular}</TableCell>
                                            <TableCell>
                                                { itemTitular.estadoApro === estadoPends ?
                                                    <Select
                                                        value={`${rows[index]['ccosto']}${charSplit}${rows[index]['cplan']}`}
                                                        label="Centro Costo"
                                                        fullWidth
                                                        required
                                                        onChange={(e) => handleInputChange(index, itemTitular.idPlanTitular, 'ccosto', e.target.value)}
                                                    >
                                                        <MenuItem value={`0${charSplit}`}>Seleccione</MenuItem>
                                                        {getMenuItems(allEmpresas)}
                                                    </Select> : itemTitular.nmbEmpresa
                                                }
                                            </TableCell>
                                            {/* <TableCell>
                                                {  itemTitular.estadoApro === estadoPends ?
                                                    <TextField
                                                        label="Cod. Confirmación"
                                                        // value={'?'}
                                                        onKeyPress={onlyNumberTen}
                                                        fullWidth
                                                        margin="normal"
                                                        onChange={(e) => handleInputChange(index, itemTitular.idPlanTitular, 'cconf', e.target.value)}
                                                        required
                                                        // InputLabelProps={{ shrink: true }}
                                                    /> : itemTitular.codigoConfirm
                                                 }
                                            </TableCell> */}
                                            <TableCell id={`aproCheck${itemTitular.idPlanTitular}`}>
                                                { itemTitular.estadoApro === estadoPends ?
                                                    <Checkbox
                                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 38 } }}
                                                        onChange={(e) => handleInputChange(index, itemTitular.idPlanTitular, 'capro', e.target.checked)}
                                                    /> : itemTitular.estadoApro === estadoAccep ? `SÍ` : `NO`
                                                }
                                            </TableCell>
                                            <TableCell>
                                                { getSpanAprobacion(itemTitular.idPlanTitular, itemTitular.estadoApro) }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Button sx={{ marginY: 5}} variant="contained" color="primary" onClick={handleSaveAll} >
                            Guardar
                        </Button>
                    </Container>
                )}
            </Box>
            {message && <Typography color="error">{message}</Typography>}
        </Container>

    );

};

export default Dashboard;
